import script from "./ProductType.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductType.vue?vue&type=script&setup=true&lang=js"

import "./ProductType.vue?vue&type=style&index=0&id=fc6dc256&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc6dc256"]])

export default __exports__